import { useAptabase } from "@aptabase/react";
import {
  useFetchPlayersByStats,
  useFetchTeamsByStats,
} from "../../../api/hooks";
import i18n from "../../../i18n";
import PageContainer from "../../../uikit/PageContainer/PageContainer";
import { useContext, useEffect } from "react";
import { PersonsRanking } from "../components/PersonsRanking";
import { TeamsRanking } from "../components/TeamsRanking";
import { RootContext } from "../../../providers/RootProvider";

const StatsPage = () => {
  const { selectedPhaseId } = useContext(RootContext);

  const { data: playerByTries } = useFetchPlayersByStats("tries");
  const { data: playerByPoints } = useFetchPlayersByStats("points");
  const { data: teamByPointsScored } = useFetchTeamsByStats(
    "points_scored",
    selectedPhaseId
  );
  const { data: teamByPointsTaken } = useFetchTeamsByStats(
    "points_taken",
    selectedPhaseId
  );

  const hasPlayerStats =
    playerByTries &&
    playerByTries.length > 0 &&
    playerByPoints &&
    playerByPoints.length > 0;

  const { trackEvent } = useAptabase();

  useEffect(() => {
    trackEvent("page_view", { screenName: "stats_page" });
  }, [trackEvent]);

  return (
    <PageContainer title={i18n.t("navigation:stats:title")}>
      {hasPlayerStats && (
        <div className="grid sm:grid-cols-1 md:grid-cols-2">
          {playerByTries && playerByTries.length > 0 && (
            <PersonsRanking
              label={"Meilleurs marqueurs"}
              persons={
                playerByTries
                  ? playerByTries.map((player) => ({
                      ...player,
                      id: player._id,
                      points: player.tries,
                    }))
                  : []
              }
              pointLabel={"essais"}
            />
          )}
          {playerByPoints && playerByPoints.length > 0 && (
            <PersonsRanking
              label={"Meilleurs réalisateurs"}
              persons={
                playerByPoints
                  ? playerByPoints.map((player) => ({
                      ...player,
                      id: player._id,
                      // @TODO: Support stats on the player level
                      // @ts-ignore
                      points: player.points,
                    }))
                  : []
              }
              pointLabel={"points"}
            />
          )}
        </div>
      )}
      <div className="grid sm:grid-cols-1 md:grid-cols-2">
        <TeamsRanking
          label={"Meilleures attaques"}
          // @ts-ignore
          teams={
            teamByPointsScored
              ? teamByPointsScored.map((team) => ({
                  ...team,
                  id: team._id,
                  points: team.points_scored,
                  team_logo_key: team.logo_key,
                  team_name: team.name,
                }))
              : []
          }
          pointLabel={"points marqués"}
        />
        <TeamsRanking
          label={"Meilleurs défenses"}
          // @ts-ignore
          teams={
            teamByPointsTaken
              ? teamByPointsTaken.map((team) => ({
                  ...team,
                  id: team._id,
                  points: team.points_taken,
                  team_logo_key: team.logo_key,
                  team_name: team.name,
                }))
              : []
          }
          pointLabel={"points encaissés"}
        />
      </div>
    </PageContainer>
  );
};

export default StatsPage;
